export { default as Digitalizados } from "./Digitalizados"
export { default as TableDigitalizados } from "./TableDigitalizados"
export { default as DigitalizadosTrash } from "./DigitalizadosTrash"
export { default as TableDigitalizadosTrash } from "./TableDigitalizadosTrash"
export { default as DigitalizadosCreateForm } from "./DigitalizadosCreateForm"



// WEBPACK FOOTER //
// ./src/views/contratos/digitalizados/index.js